import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { EMPTY, throwError } from 'rxjs';
import { BAD_REQUEST, FORBIDDEN, INTERNAL_SERVER_ERROR, NOT_FOUND, UNAUTHORIZED } from 'http-status-codes';
import { Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';
import { EcpErrorHandler } from '../services';
import { Store } from '@ngrx/store';
import { AppState, KpiActionTypes, OrdersActionTypes } from '@app/core/ngrx';
import { MsalService } from '@azure/msal-angular';
import {
  captureBrowserNetworkFailure,
  captureServerHttpError,
  ServerHttpErrorDiagnostics,
} from '@app/core/observability/observability';
import { environment } from '@env/environment';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private inject: Injector, private authService: MsalService, private store: Store<AppState>) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        const diagnostics = this.buildErrorDiagnostics(req, err);
        captureBrowserNetworkFailure(environment, err, diagnostics);
        captureServerHttpError(environment, err, diagnostics);

        const errorCode = err.status;
        const notifier = this.inject.get(NotificationService);
        const router = this.inject.get(Router);
        switch (errorCode) {
          case UNAUTHORIZED:
            // this.authService.logout();
            return EMPTY;
          case FORBIDDEN:
          // if (req.url.endsWith('/user/resetpassword')) {
          //   notifier.error(EcpErrorHandler.RESETPW_ERROR_MESSAGE);
          //   return throwError(err);
          // } else {
          //   router.navigateByUrl('/');
          //   return EMPTY;
          // }
          case BAD_REQUEST:
            if (req.url.indexOf('bulk-upload') !== -1) {
              return EMPTY;
            } else {
              notifier.error(EcpErrorHandler.DEFAULT_ERROR_MESSAGE);
              return EMPTY;
            }
          case NOT_FOUND:
            if (req.url.indexOf('api/v1/orders/MED') !== -1) {
              notifier.error(EcpErrorHandler.SETUP_ERROR_MESSAGE);
              this.store.dispatch({
                type: OrdersActionTypes.LOAD_ORDERS_ERROR,
                payload: err,
              });
              return EMPTY;
            } else if (req.url.indexOf('api/metrics/qlik') !== -1) {
              notifier.error(EcpErrorHandler.SETUP_ERROR_MESSAGE);
              this.store.dispatch({
                type: KpiActionTypes.LOAD_KPI_ERROR,
                payload: err,
              });
              return EMPTY;
            } else {
              notifier.error(EcpErrorHandler.DEFAULT_ERROR_MESSAGE);
              return throwError(err);
            }
          case INTERNAL_SERVER_ERROR:
            if (req.url.indexOf('/essiloradmin/orders') !== -1) {
              notifier.error(EcpErrorHandler.EA_RPT_ERROR_MESSAGE);
              return throwError(err);
            }
            if (req.url.indexOf('frame-trace') !== -1) {
              notifier.error(EcpErrorHandler.FT_ERROR_MESSAGE);
              return throwError(err);
            }
            if (req.url.indexOf('user/expire_password') !== -1) {
              notifier.error(EcpErrorHandler.SETUP_ERROR_MESSAGE);
            }
            return EMPTY;
          case 0:
            return EMPTY;
          default:
            // notifier.error(EcpErrorHandler.DEFAULT_ERROR_MESSAGE);
            // return throwError(err);
            return EMPTY;
        }
      }),
    );
  }

  private buildErrorDiagnostics(req: HttpRequest<any>, err: HttpErrorResponse): ServerHttpErrorDiagnostics {
    const requestUrl = req.urlWithParams || req.url || err.url || '';
    const correlationId =
      err.headers?.get('x-correlation-id') ||
      err.headers?.get('x-request-id') ||
      err.headers?.get('request-id') ||
      undefined;

    return {
      requestMethod: req.method,
      requestUrl,
      statusText: err.statusText,
      correlationId,
    };
  }
}
